import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AccessIcon from 'assets/icons/AccessIcon';
import ActionButton from 'components/button/ActionButton';
import ReservationOpenBarrierModal from './ReservationOpenBarrierModal';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { fetchAccessPointAccessMethods } from 'store/actions/accessPoints/access-methods/fetch/fetchAccessPointAccessMethods';
import { fetchAccessPoints } from 'store/actions/accessPoints/fetchAccessPoints';
import { pickBy } from 'lodash';
import { reservationSessionOpenBarrier } from 'store/actions/reservations/session/reservationSessions';
import accessMethodsHelper from 'helpers/accessMethodsHelper';
import translate from 'components/hoc/translate';

class ReservationOpenBarrierContainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            loading: false,
            phase: 'options',
        };
    }

    componentDidMount() {
        this.props.dispatchFetchAccessPoints(this.props.product.id);
    }

    openModal = () => {
        this.setState({ open: true });
    }

    closeModal = () => {
        this.setState({
            open: false,
            loading: false,
            phase: 'options',
        });
    }

    handleSubmit = (formValues) => {
        const {
            dispatchForm,
            id,
            translate,
        } = this.props;

        const {
            access_points_access_method_id,
            execute_access,
        } = formValues;

        dispatchForm({
            id: id,
            params: {
                access_points_access_method_id,
                execute_access,
            },
            onSuccess: () => {
                this.setState({
                    phase: 'result',
                    message: translate('resources.reservations.open_barrier.modal.success'),
                });
            },
            onError: (error) => {
                const updatedState = {
                    message: translate('resources.reservations.open_barrier.modal.error'),
                    phase: 'result',
                };

                if (error.message === 'session-open-barrier-requires-access-point') {
                    updatedState.message = translate('resources.reservations.open_barrier.modal.session_open_barrier_requires_access_point');
                } else if (error.message === 'force-not-allowed-for-access-method') {
                    updatedState.message = translate('resources.reservations.open_barrier.modal.force_not_allowed_for_access_method');
                }

                this.setState(updatedState);
            },
        });
    }

    onSelectAccessPoint = (accessPointId) => {
        this.props.dispatchFetchAccessPointAccessMethods(accessPointId);
    }

    render() {
        const {
            accessPoints,
            accessPointsAccessMethods,
            isLoading,
            translate,
        } = this.props;

        const {
            message,
            phase,
        } = this.state;

        if (!accessPoints || !accessPointsAccessMethods) {
            return null;
        }
        return (
            <div>
                <ActionButton
                    disabled={ false }
                    icon={ <AccessIcon /> }
                    onClick={ this.openModal }
                    title={ 'Open Barrier' }
                />

                { this.state.open && (
                    <ReservationOpenBarrierModal
                        accessPoints={ accessPoints }
                        accessPointsAccessMethods={ accessPointsAccessMethods }
                        isLoading={ isLoading }
                        message={ message }
                        onCloseModal={ this.closeModal }
                        onHandleSubmit={ this.handleSubmit }
                        onSelectAccessPoint={ this.onSelectAccessPoint }
                        phase={ phase }
                        translate={ translate }
                    />
                )}

            </div>
        );
    }
}

ReservationOpenBarrierContainer.propTypes = {
    accessPoints: PropTypes.object,
    accessPointsAccessMethods: PropTypes.object,
    dispatchFetchAccessPointAccessMethods: PropTypes.func,
    dispatchFetchAccessPoints: PropTypes.func,
    dispatchForm: PropTypes.func,
    id: PropTypes.number.isRequired,
    isLoading: PropTypes.bool,
    product: PropTypes.object,
    translate: PropTypes.func,
};

const mapStateToProps = (state) => {
    return {
        accessPoints: pickBy(state['access-points'].data, ({ type }) => {
            return type === 'access';
        }),
        accessPointsAccessMethods: pickBy(state['access-points-access-methods'].data, ({ access_method_id }) => {
            return accessMethodsHelper.isAllowedForceBarrier(access_method_id);
        }),
        isLoading: state['access-points-access-methods'].loading,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchFetchAccessPoints: (productId) => {
            dispatch(fetchAccessPoints({
                product_id: productId,
            }));
        },
        dispatchFetchAccessPointAccessMethods: (access_point_id) => {
            dispatch(fetchAccessPointAccessMethods({
                access_point_id,
            }));
        },
        dispatchForm: (values) => {
            dispatch(reservationSessionOpenBarrier(values));
        },
    };
};

const enhance = compose(
    translate,
    connect(
        mapStateToProps,
        mapDispatchToProps
    ),
);

export default enhance(ReservationOpenBarrierContainer);



// WEBPACK FOOTER //
// ./src/pages/reservations/show/open-barrier/ReservationOpenBarrierContainer.js